import { Route, Routes, Outlet, useLocation } from 'react-router-dom'
import './App.scss'
import {
    Footer,
    Loader,
    Navbar,
    PrivacyPolicy,
    Accessibility,
} from '@components'
import {
    Error404,
    Blog,
    Expertise,
    ExpertisePage,
    Recruitment,
    OfficeDetail,
    WhoWeAre,
    BlogDetailPage,
    Realisation,
    ExpertiseDetail,
    ExpertiseArticleLayout,
} from '@layouts'
import { useEffect } from 'react'
import { usePageLoading } from './context/PageLoadingContext'
import { useDelayedLoading } from './hooks/loading/useDelayedLoading'

const PageLayout = () => {
    const { isPageLoading } = usePageLoading()
    const isDelayedLoading = useDelayedLoading(isPageLoading, 300)

    return (
        <>
            <a
                href="#main-content"
                className="skip-link"
                onKeyDown={(e) => {
                    if (e.key === ' ') {
                        e.preventDefault()
                        e.currentTarget.click()
                    }
                }}
            >
                Aller au contenu principal
            </a>
            <Navbar />
            <main id="main-content" tabIndex={-1}>
                {isDelayedLoading && <Loader />}
                <div style={{ display: isDelayedLoading ? 'none' : 'block' }}>
                    <Outlet />
                </div>
            </main>
            <Footer />
        </>
    )
}

function App() {
    const { pathname } = useLocation()

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [pathname])

    return (
        <div className="App">
            <Routes>
                <Route element={<PageLayout />}>
                    <Route path="/expertises" element={<Expertise />} />
                    <Route path="/realisation" element={<Realisation />} />
                    <Route path="/expertises/:id" element={<ExpertisePage />} />
                    <Route
                        path="/realisation-detail/:expertiseId/:caseId"
                        element={<ExpertiseDetail />}
                    />
                    <Route
                        path="/expertise-article-detail/:expertiseId/:caseId"
                        element={<ExpertiseArticleLayout />}
                    />
                    <Route path="/actualites" element={<Blog />} />
                    <Route path="/notre-ecosysteme" element={<Expertise />} />
                    <Route path="/nous-rejoindre" element={<Recruitment />} />
                    <Route path="/office/:id" element={<OfficeDetail />} />
                    <Route path="/newsroom" element={<Blog />} />
                    <Route
                        path="/blog-detail/:blogDetailId"
                        element={<BlogDetailPage />}
                    />
                    <Route path="/qui-sommes-nous" element={<WhoWeAre />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route
                        path="/declaration-accessibilite"
                        element={<Accessibility />}
                    />
                    <Route path="*" element={<Error404 />} />
                </Route>
            </Routes>
        </div>
    )
}

export default App
